import AnimationPropTypes from '../../modules/AnimationPropTypes';
import BorderPropTypes from '../../modules/BorderPropTypes';
import ColorPropType from '../ColorPropType';
import ImageResizeMode from './ImageResizeMode';
import InteractionPropTypes from '../../modules/InteractionPropTypes';
import LayoutPropTypes from '../../modules/LayoutPropTypes';
import ShadowPropTypes from '../../modules/ShadowPropTypes';
import TransformPropTypes from '../../modules/TransformPropTypes';
import { number, oneOf, string } from 'prop-types';

var ImageStylePropTypes = Object.assign({}, AnimationPropTypes, BorderPropTypes, InteractionPropTypes, LayoutPropTypes, ShadowPropTypes, TransformPropTypes, {
  backgroundColor: ColorPropType,
  opacity: number,
  resizeMode: oneOf(Object.keys(ImageResizeMode)),
  tintColor: ColorPropType,
  /**
   * @platform unsupported
   */
  overlayColor: string,
  /**
   * @platform web
   */
  boxShadow: string,
  filter: string
});

export default ImageStylePropTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/exports/Image/ImageStylePropTypes.js
// module id = 433
// module chunks = 0